
import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from "@roc/ui";
import { observer } from "mobx-react";
import AddPointOfContactQuestion from "./AddPointOfContactQuestionContent";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: 24,
  },
  container: {
    padding: 16,
  }
}));

const AddPointOfContactCard = observer((loanDetails) => {
  const classes = useStyles();

  return (
    <Grid item md={6} xs={12}>
      <Paper className={classes.paper}>
        <AddPointOfContactQuestion loanDetails={loanDetails} classes={classes.container} />
      </Paper>
    </Grid>
  )
});

export default AddPointOfContactCard;